module.exports = "/assets/mobile-banner/rw.gif?h1q8A6C";